import { useTranslation } from "react-i18next";

import { AboutPage } from "./AboutPage";
import logo from "./logo.svg";

// import { ContentArea } from "../../components/ContentArea";
// import { ToolbarTop } from "../../components/ToolbarTop";

export default function AboutProgram() {
  const { t } = useTranslation();
  return (
    // <ContentArea>
    //   <ToolbarTop pageTitle={t("navigation.aboutProgram")}></ToolbarTop>
      <AboutPage
        title={t("login.applicationName")}
        version={t("login.appVersion")}
        logo={logo}
      />
    // </ContentArea>
  );
}